import { FC } from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import { CorporateNumberFormBase } from '../../FormBases';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
  error: FieldError | undefined;
};

/**
 * 新規登録モーダル用の顧客番号フォームです。
 */
export const CorporateNumberForm: FC<Props> = ({ register, error }) => (
  <FormControl isInvalid={Boolean(error)}>
    <FormLabel>法人番号</FormLabel>
    <CorporateNumberFormBase register={register} />
    <FormErrorMessage>{error && error.message}</FormErrorMessage>
  </FormControl>
);
